import { api } from '../../lib/apiClient';

export type ApiKey = {
  id: string;
  organization_id: string;
  name: string;
  type: 'publishable' | 'secret';
  key_prefix: string;
  created_by: string;
  created_at: string;
  last_used_at?: string | null;
  revoked_at?: string | null;
  /**
   * IP allowlist for secret keys. Empty array means "no restriction" and is
   * the default for back-compat. Always serialized (never omitted) so the
   * UI can detect "explicitly empty" without ambiguity.
   */
  allowed_cidrs: string[];
};

export type CreatedApiKey = ApiKey & { cleartext: string };

export async function listApiKeys(orgId: string): Promise<ApiKey[]> {
  const res = await api.get<{ data: ApiKey[] }>(`/v1/orgs/${orgId}/api-keys`);
  return res.data.data;
}

export async function createApiKey(
  orgId: string,
  input: { name: string; type: 'publishable' | 'secret'; allowed_cidrs?: string[] },
): Promise<CreatedApiKey> {
  const res = await api.post<{ data: CreatedApiKey }>(`/v1/orgs/${orgId}/api-keys`, input);
  return res.data.data;
}

export async function updateApiKey(
  orgId: string,
  keyId: string,
  input: { allowed_cidrs: string[] },
): Promise<void> {
  await api.patch(`/v1/orgs/${orgId}/api-keys/${keyId}`, input);
}

export async function revokeApiKey(orgId: string, keyId: string): Promise<void> {
  await api.delete(`/v1/orgs/${orgId}/api-keys/${keyId}`);
}
